import {BaseModel} from "../base";

class SettingsUserModel extends BaseModel {

    constructor(data) {
        super(data);
        this.companies = [];
        if (data) {
            if (this.$has('companies')) {
                this.$get('companies').then((comps) => {
                        return this.companies = comps;
                    }
                );
            }
        }
    }
}

export {
    SettingsUserModel
}